export { default, type VideoRevealProps } from './VideoReveal';
